import { render, staticRenderFns } from "./SupplierSizeCreateOrUpdateDialog.vue?vue&type=template&id=2fbcbb66"
import script from "./SupplierSizeCreateOrUpdateDialog.ts?vue&type=script&lang=ts&external"
export * from "./SupplierSizeCreateOrUpdateDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports